import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator
} from "react-material-ui-form-validator";
import { authWrapper } from "../../../auth";
import FormButton from "./FormButton";
import { withSnackbar } from "notistack";

import SERVER_ADDRESS from "../../../config";
import store from "../../../reduxstore";

const useStyles = makeStyles(theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  input: {
    display: "none"
  },
  submit: {
    marginTop: theme.spacing(3)
  }
}));

//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//Main Component
function EditGoujianDialogButton(props) {
  const classes = useStyles();
  const [open, handleClickOpen, handleClose] = useDialog();
  const [canSubmit, setCansubmit] = useState(true);

  const useButton = props.button;
  const { buttonText, initFormValue, freshData } = props;
  const { categoryOptions } = store.getState();

  const validateRefs = {
    name: React.createRef(),
    description: React.createRef(),
    category: React.createRef()
  };

  //filefield Ref
  const sketchInputRef = React.createRef();
  const obj_modelInputRef = React.createRef();

  //提交需要的json
  let initState, submitUrl, method;
  if (initFormValue) {
    initState = {
      name: initFormValue.name,
      description: initFormValue.description,
      category: initFormValue.category
    };
    submitUrl = `${SERVER_ADDRESS}/api/goujians/${initFormValue.id}/`;
    method = "PATCH";
  }

  //create
  else {
    initState = {
      name: "",
      description: "",
      category: "",
      sketch: "",
      obj_model: ""
    };
    submitUrl = `${SERVER_ADDRESS}/api/goujians/`;
    method = "POST";
  }

  const [formValue, setFromValue] = useState(initState);

  const handleChange = name => event => {
    setFromValue({ ...formValue, [name]: event.target.value });
  };

  const handleFileInput = name => ({ target }) => {
    const file = target.files[0];
    console.log(file);
    setFromValue({ ...formValue, [name]: file });
  };

  //表单数据提交
  const handleSubmitWithFile = (postUrl, formValue, method) => {
    return () => {
      setCansubmit(false);

      let h = new Headers();
      h.append("Accept", "application/json");
      let formdata = new FormData();
      Object.keys(formValue).forEach(value => {
        formdata.append(value, formValue[value]);
        console.log(value, formValue[value]);
      });

      let req = new Request(postUrl, {
        method: method,
        headers: {
          Accept: "application/json, text/plain, */*"
        },
        mode: "cors",
        credentials: "include",
        body: formdata
      });

      fetch(req)
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then(data => {
          console.log(data);
          //close dialog after finish post

          handleClose();
          setFromValue({
            name: data.name,
            description: data.description,
            category: data.category
          });
          setCansubmit(true);

          //刷新因表单修改更新的数据
          if (freshData) {
            freshData(data);
          }

          //提交成功后的反馈SnackBar
          props.enqueueSnackbar("构件数据提交成功", {
            variant: "success"
          });
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          setCansubmit(true);
          props.enqueueSnackbar("提交构件信息失败,请检查内容格式", {
            variant: "error"
          });
        });
    };
  };

  const handleBlur = refname => {
    return event => {
      validateRefs[refname].current.validate(event.target.value);
    };
  };
  return (
    <div>
      <FormButton
        handleClickOpen={handleClickOpen}
        buttonText={buttonText}
        button={useButton}
      />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{initFormValue ? "编辑构件信息" : "新建构件"}</DialogTitle>
        <DialogContent>
          <ValidatorForm
            onSubmit={handleSubmitWithFile(submitUrl, formValue, method)}
            instantValidate={true}
            noValidate
          >
            <input
              id="sketch"
              ref={sketchInputRef}
              multiple
              required
              accept=".jpg,.jpeg"
              onChange={handleFileInput("sketch")}
              style={{ display: "none" }}
              type="file"
            />
            <InputLabel htmlFor="sketch">
              <Button
                variant="contained"
                color="primary"
                component="span"
                className={classes.button}
              >
                {initFormValue ? "更新构件示意图" : "上传构件示意图"}
                <CloudUploadIcon className={classes.rightIcon} />
              </Button>
              <Typography component="span" variant="body2">
                {formValue.sketch ? formValue.sketch.name : " "}
              </Typography>
            </InputLabel>

            <input
              id="obj_model"
              multiple
              required
              accept=".obj"
              onChange={handleFileInput("obj_model")}
              style={{ display: "none" }}
              type="file"
            />
            <InputLabel htmlFor="obj_model">
              <Button
                variant="contained"
                color="primary"
                component="span"
                className={classes.button}
              >
                {initFormValue ? "更新构件模型" : "上传构件模型"}
                <CloudUploadIcon className={classes.rightIcon} />
              </Button>
              <Typography component="span" variant="body2">
                {formValue.obj_model ? formValue.obj_model.name : " "}
              </Typography>
            </InputLabel>

            <TextValidator
              ref={validateRefs.name}
              margin="normal"
              autoFocus
              required
              fullWidth
              id="name"
              label="构件名称"
              value={formValue.name}
              onChange={handleChange("name")}
              onBlur={handleBlur("name")}
              validators={["required"]}
              errorMessages={["构件名称不可为空"]}
              helperText="填写构件的学术名称"
            />

            <TextValidator
              ref={validateRefs.description}
              margin="normal"
              required
              fullWidth
              multiline
              id="description"
              label="构件解释"
              value={formValue.description}
              onChange={handleChange("description")}
              onBlur={handleBlur("description")}
              validators={["required"]}
              errorMessages={["构件解释内容不可为空"]}
              helperText="填写解释构件位置、属性的文本"
            />

            <SelectValidator
              ref={validateRefs.category}
              margin="normal"
              required
              select
              id="category"
              label="构件类型"
              value={formValue.category}
              onChange={handleChange("category")}
              InputLabelProps={{
                shrink: true
              }}
              onBlur={handleBlur("category")}
              validators={["required"]}
              errorMessages={["必须选择构件的类型"]}
              helperText="请选择构件的类型"
            >
              {categoryOptions.map(option => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </SelectValidator>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              className={classes.submit}
              disabled={!canSubmit}
            >
              {canSubmit ? "提交" : "发送中···"}
            </Button>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const withSnackbarEditGoujianDialogButton = withSnackbar(
  EditGoujianDialogButton
);
const AuthEditGoujianDialogButton = authWrapper(["教师"])(
  withSnackbarEditGoujianDialogButton
);
export default AuthEditGoujianDialogButton;
